
import React, { useEffect, useState } from "react";
import ViewSDKClient from "./LoadPdf";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import Loader from "../Loader/Loader";
import { convertBufferArrayToBase64 } from "../../utils/ImageToBase64";
import { failed, success } from "../../utils/Tostify";
import { useDispatch, useSelector } from "react-redux";
import { getApplicationById, updateApplication, updateTask } from "../../api/Applications";
import { decryptData } from "../../utils/helper";

const PdfViewer = ({ url, setShowModal, formData, is_apl_view, refetch, type }) => {

  let token = useSelector((state) => state.userReducer.token);
  const dispatch  = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const viewSDKClient = new ViewSDKClient();
  let user = useSelector((state) => state.userReducer.user);

  useEffect(() => {
    viewSDKClient.savePdfHandler = savePdfHandler;

    if (viewSDKClient.savePdfHandler) {
      viewSDKClient.savePdfHandler();
    }
  }, []);

  useEffect(() => {
    const loadPDF = () => {
      viewSDKClient.ready().then(() => {
        viewSDKClient.previewFile(
          "pdf-div",
          {
            embedMode: "FULL_WINDOW",
            defaultViewMode: "FIT_WIDTH",
            showAnnotationTools: !formData?.lockStatus,
            showLeftHandPanel: !formData?.lockStatus,
            showPageControls: true,
            showDownloadPDF: !formData?.lockStatus,
            showPrintPDF: !formData?.lockStatus,
            enableFormFilling: !formData?.lockStatus
          },
          url
        );
        viewSDKClient.registerSaveApiHandler(); // Register the save handler
      });
    };

    loadPDF();
  }, [url]);

  const savePdfHandler = async () => {
    // Retrieve the stored PDF content buffer
    let res;
    const pdfContent = viewSDKClient.getPdfContent();
    if (pdfContent) {
      const base64String = convertBufferArrayToBase64(pdfContent);
      const prefixedBase64String = `data:application/pdf;base64,${base64String}`;

      const pdfForm = {
          base64String: prefixedBase64String,
          extension: "pdf",
          name: "update"
      };
      const payload = {
        formId : is_apl_view ? formData?._id : formData?.formId,
        // status: "InProgress",
        status: "Completed",
        pdfForm,
        updatedBy: user._id,
        type
      };
      const applicationId = formData?.applicationId;
      setIsLoading(true);
      res = await viewSDKClient.sendToServer(payload, dispatch, token, applicationId);
      if (res?.status === "SUCCESS") {
        const data = await getApplicationById({ dispatch, token, applicationId: applicationId });
        const responseData = decryptData(data?.data);
        const updatedApplicationForm = responseData?.applicationForms.map((form)=> {
          if(form.formId === formData?.formId){
            return {
              ...form,
              // status : "InProgress"
              status: "Completed"
            };
          }
          return form;
        });
        const values = {applicationForms : updatedApplicationForm};
        setIsLoading(true);
        res = await updateApplication({values, dispatch, token, applicationId : formData?.applicationId});
        if(!is_apl_view){
        // const payloadData = {tasks : {"status": "InProgress"}};
        const payloadData = {tasks : {"status": "Completed"}};
        res = await updateTask({values: payloadData, dispatch, token, applicationId: formData?.applicationId, taskId: formData?._id});
        }
        if (typeof refetch === "function") {
          await refetch();
        }
        success(res.message);
        setShowModal(false);
        setIsLoading(false);
      }else{
        setIsLoading(false);
        failed(res?.message);
      }
    } else {
      console.error("PDF content not available. Make sure the SAVE_API has been triggered.");
    }
  };

  const VerifyForm = async () => {
    let res;
    try {
    const payload = {tasks : {"status": "Completed"}  };
    setIsLoading(true);
    res = await updateTask({values:payload, dispatch, token, applicationId: formData?.applicationId, taskId: formData?._id});
      if (res?.status === "SUCCESS") {
        success(res.message);
        setIsLoading(false);
      }else{
        setIsLoading(false);
        failed(res?.message);
      }
    }catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };

  return (
    <Modal isOpen={setShowModal} toggle={setShowModal} size="xl">
      <ModalHeader toggle={setShowModal} className="assign_blk p-0 mb-3">{(formData?.lockStatus || formData?.status === "Completed") ? "View Form" : "Edit Form"}</ModalHeader>
      <ModalBody className="form-add override-height">
        {isLoading ? <Loader /> : null}
        <div className="mt-28">
          <div
            style={{ height: "100vh" }}
            id="pdf-div"
            className="full-window-div border border-gray-100 h-screen"
          ></div>
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="d-flex justify-content-between">
          {!formData?.lockStatus && formData.taskAction  === "Verify Form" &&
          <Button color="primary" className="save_btn" onClick={()=> VerifyForm()}> Save</Button>
          }
        </div>
      </ModalFooter>
    </Modal>

  );
};
export default PdfViewer;
